document.addEventListener("contextmenu", function (e) {
  if (e.target.tagName === "IMG") {
    e.preventDefault();
  }
});

(() => {
  // Inject CSS to deter long-press/save on phones
  const style = document.createElement('style');
  style.textContent = `
    img{
      -webkit-touch-callout:none;
      -webkit-user-select:none;user-select:none;
      -webkit-user-drag:none;user-drag:none;
    }
  `;
  document.documentElement.appendChild(style);

  function harden(img){
    if (!(img instanceof HTMLImageElement)) return;
    img.setAttribute('draggable','false');
    img.addEventListener('contextmenu', e => e.preventDefault()); // block save menu
    img.addEventListener('dragstart', e => e.preventDefault());

    // Block long-press on touch
    let timer;
    img.addEventListener('touchstart', e => {
      timer = setTimeout(() => { try{ e.preventDefault(); }catch(_){} }, 300);
    }, {passive:false});
    ['touchend','touchcancel','touchmove'].forEach(t =>
      img.addEventListener(t, () => clearTimeout(timer), {passive:true})
    );
  }

  // Apply to existing images
  document.querySelectorAll('img').forEach(harden);

  // Catch context menu bubbling from any image
  document.addEventListener('contextmenu', e => {
    if (e.target.closest('img')) e.preventDefault();
  }, true);

  // Apply to future images (lazy-loaded, AJAX, etc.)
  new MutationObserver(muts => {
    for (const m of muts){
      for (const n of m.addedNodes){
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'IMG') harden(n);
        n.querySelectorAll && n.querySelectorAll('img').forEach(harden);
      }
    }
  }).observe(document.documentElement, {childList:true, subtree:true});
})();